import { Link } from 'react-router-dom';

export const Cookies = () => (
  <div className="min-h-screen bg-[#0A0A0A] text-white">
    <div className="max-w-3xl mx-auto px-6 py-24">
      <Link to="/" className="font-mono text-[11px] tracking-widest uppercase text-gold hover:text-white transition-colors mb-12 inline-block">
        ← Volver
      </Link>
      <h1 className="font-display text-4xl font-light mb-12">Política de Cookies</h1>

      <div className="space-y-10 font-sans text-sm text-white/70 leading-relaxed">

        <section>
          <h2 className="text-white font-medium mb-3">1. ¿Qué son las cookies?</h2>
          <p>Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Permiten al sitio recordar tus preferencias y mejorar tu experiencia de navegación.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">2. Cookies que utilizamos</h2>
          <div className="overflow-x-auto mt-3">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left py-3 pr-4 text-white/90 font-medium">Nombre</th>
                  <th className="text-left py-3 pr-4 text-white/90 font-medium">Proveedor</th>
                  <th className="text-left py-3 pr-4 text-white/90 font-medium">Tipo</th>
                  <th className="text-left py-3 text-white/90 font-medium">Finalidad</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-white/5">
                  <td className="py-3 pr-4">Google Fonts</td>
                  <td className="py-3 pr-4">Google LLC</td>
                  <td className="py-3 pr-4">Técnica</td>
                  <td className="py-3">Carga de tipografías. Solo transmite la IP de forma transitoria, sin cookies.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-4 text-white/50">El Sitio no utiliza cookies analíticas, publicitarias ni de seguimiento. No se requiere banner de consentimiento conforme a la Guía de Cookies de la AEPD (2023).</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">3. Cómo desactivar las cookies</h2>
          <p>Puedes configurar tu navegador para rechazar o eliminar cookies en cualquier momento. Ten en cuenta que desactivar cookies técnicas puede afectar al correcto funcionamiento del Sitio.</p>
          <ul className="mt-3 space-y-1 list-disc list-inside text-white/60">
            <li>Chrome: Configuración → Privacidad y seguridad → Cookies</li>
            <li>Firefox: Opciones → Privacidad y seguridad</li>
            <li>Safari: Preferencias → Privacidad</li>
            <li>Edge: Configuración → Privacidad, búsqueda y servicios</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">4. Actualizaciones</h2>
          <p>Si en el futuro incorporamos cookies analíticas o publicitarias, actualizaremos esta política e implementaremos el mecanismo de consentimiento correspondiente.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">5. Contacto</h2>
          <p>Para cualquier consulta sobre nuestra política de cookies: <strong className="text-white/90">legal@lycconsulting.com</strong></p>
        </section>

        <p className="text-white/40 text-xs pt-4">Última actualización: mayo 2026</p>
      </div>
    </div>
  </div>
);
